import { graphql } from "../gql";

export const getDrgMasterCodesQueryDoc = graphql(`
  query drgMasterCodes($input: DrgMasterCodesInput!) {
    drgMasterCodes(input: $input) {
      id
      name
      description
    }
  }
`);
